export function normalizeFolderName(value: string): string {
  return value
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\s*\.\s*/g, ".");
}

export function folderNamesMatch(left: string, right: string): boolean {
  return normalizeFolderName(left).localeCompare(normalizeFolderName(right), undefined, {
    sensitivity: "accent",
  }) === 0;
}

export function hasSiblingFolderName(
  siblings: Array<{ name: string; code?: string }>,
  folderName: string
): boolean {
  const trimmed = folderName.trim();
  if (!trimmed) {
    return false;
  }

  return siblings.some((sibling) => {
    if (folderNamesMatch(sibling.name, trimmed)) {
      return true;
    }

    const code = (sibling.code ?? "").trim();
    return Boolean(code) &&
      code.toUpperCase() !== "CUSTOM" &&
      folderNamesMatch(code, trimmed);
  });
}
